import { render, staticRenderFns } from "./popup-transport-fee.vue?vue&type=template&id=fd9d0a7c&"
import script from "./popup-transport-fee.vue?vue&type=script&lang=js&"
export * from "./popup-transport-fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports